<template>
  <div id="pageRomaneioImages">
    <v-snackbar
      :timeout="3000"
      bottom
      right
      :color="snackbar.color"
      v-model="snackbar.show"
    >
      {{ snackbar.text }}
      <v-btn dark text @click.native="snackbar.show = false" icon>
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>

    <div class="text-center">
      <v-dialog v-model="downloadImagesDialog" persistent width="300">
        <v-card color="primary" dark>
          <v-card-text class="pa-5">
            <span>Baixando Imagens...</span>
            <v-progress-linear
              v-model="totalDownloadedInPercent"
              height="25"
              color="blue"
              class="mb-0"
            >
              <strong>{{ totalDownloadedInPercent }}%</strong>
            </v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>

    <v-container grid-list-lg fluid>
      <div class="text-center">
        <v-progress-circular
          indeterminate
          color="primary"
          v-if="load"
        ></v-progress-circular>
      </div>

      <v-layout row wrap v-if="romaneio">
        <v-flex xs12>
          <v-btn @click="getImages" :loading="loadingImages" color="primary"
            >Baixar todas as imagens</v-btn
          >
        </v-flex>
        <v-flex
          xs12
          sm6
          md4
          v-for="(animal, index) in romaneio.animals"
          v-observe-visibility="{
            callback: (isVisible, entry) => loadImage(isVisible, animal),
            once: true
          }"
          :key="'photo_' + index"
        >
          <app-romaneio-card-image :animal="animal" :auxs="auxs">
          </app-romaneio-card-image>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Vue from 'vue'
import appApi from '../../plugins/api'
import CardImage from '@/components/romaneio/CardImage.vue'
import axios from 'axios'
import JSZip from 'jszip'
import { saveAs } from 'file-saver'
export default {
  components: {
    'app-romaneio-card-image': CardImage
  },
  data: function() {
    return {
      romaneio: null,
      load: true,
      auxs: [],
      loadingImages: false,
      totalDownloaded: 0,
      downloadImagesDialog: false,
      totalDownloadedInPercent: 0,
      snackbar: {}
    }
  },

  computed: {},

  mounted: function() {
    window.scrollTo(0, 0)

    if (this.$route.params.id) {
      appApi.getRomaneioAuxs().then(result => {
        this.auxs = result.data
        this.getRomaneio(this.$route.params.id)
      })
    } else {
      this.load = false
    }
  },

  methods: {
    getRomaneio: function(id) {
      appApi
        .getRomaneio(id)
        .then(result => {
          this.romaneio = result.data
          this.load = false
        })
        .catch(error => {
          this.load = false
        })
    },

    loadImage: function(isVisible, animal) {
      if (!isVisible || 'image' in animal) {
        return
      }

      appApi
        .getRomaneioImages(animal.track_id, animal.nr_sequencial_ind)
        .then(result => {
          if (result.data[0]) Vue.set(animal, 'image', result.data[0][0])
          else
            Vue.set(
              animal,
              'image',
              '/static/attachment-no-image-available.png'
            )
        })
    },

    async getImages() {
      var zip = new JSZip()
      var img = zip.folder('images')
      let total = 0

      this.loadingImages = true
      this.downloadImagesDialog = true

      const imageUrls = await Promise.all(
        this.romaneio.animals.map(async animal => {
          const response = await appApi.getRomaneioImages(
            animal.track_id,
            animal.nr_sequencial_ind
          )

          if (response && response.data && response.data.length > 0) {
            this.totalDownloaded += this.totalDownloaded
            this.calculateDownloadedPercent(this.romaneio.length)

            return {
              url: response.data[0][0],
              imageName:
                animal.track_id + '-' + animal.nr_sequencial_ind + '.jpg'
            }
          }
        })
      )

      const filteredUrls = imageUrls.filter(Boolean)

      if (filteredUrls.length > 0) {
        this.totalDownloadedInPercent = 0
        this.totalDownloaded = 0
        this.calculateDownloadedPercent(filteredUrls.length)

        filteredUrls.map(({ url, imageName }) => {
          this.toDataURL(
            url,
            dataURL => {
              var imageData = dataURL.replace('data:image/jpeg;base64,', '')
              img.file(imageName, imageData, { base64: true })
              total++
              this.totalDownloaded = total
              this.calculateDownloadedPercent(filteredUrls.length)
              this.downloadImages(total, zip, filteredUrls.length)
            },
            'image/jpeg'
          )
        })
      } else {
        this.loadingImages = false
        this.downloadImagesDialog = false
        this.snackbar = {
          show: true,
          text: 'Erro ao baixar imagens',
          color: 'error'
        }
      }
    },

    calculateDownloadedPercent(totalImages) {
      this.totalDownloadedInPercent = Math.ceil(
        (this.totalDownloaded * 100) / totalImages || 0
      )
    },

    downloadImages(total, zip, totalFiltered) {
      if (total == totalFiltered) {
        this.loadingImages = false
        this.downloadImagesDialog = false

        zip.generateAsync({ type: 'blob' }).then(function(content) {
          saveAs(content, 'romaneio.zip')
        })
      }
    },

    toDataURL(src, callback, outputFormat) {
      var img = new Image()
      img.crossOrigin = 'Anonymous'
      img.onload = function() {
        var canvas = document.createElement('CANVAS')
        var ctx = canvas.getContext('2d')
        var dataURL
        canvas.height = this.naturalHeight
        canvas.width = this.naturalWidth
        ctx.drawImage(this, 0, 0)
        dataURL = canvas.toDataURL(outputFormat)
        callback(dataURL)
      }

      // RESETA O CACHE DO GOOGLE CHROME
      img.src = src + '&x-request=xhr'

      if (img.complete || img.complete === undefined) {
        console.log('FEITOFEITOFEITOFEITO')
        img.src =
          'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw=='
        img.src = src
      }
    }
  }
}
</script>
<style scoped lang="css"></style>
